import { format, endOfMonth, startOfMonth, parseISO } from "date-fns";
//月をフォーマットする関数
export function formatMonth(date: Date): string {
  return format(date, "yyyy-MM");
}
//日付をフォーマットする関数
export function formatDate(date: Date): string {
  return format(date, "yyyy-MM-dd");
}
//月初日を取得する関数
export function formatStartOfMonth(date: Date): string {
  return format(startOfMonth(date), "yyyy-MM-dd");
}
//月末日を取得する関数
export function formatEndOfMonth(date: Date): string {
  return format(endOfMonth(date), "yyyy-MM-dd");
}
//数字を通貨形式に変換する関数
export function formatCurrency(amount: number): string {
  return amount.toLocaleString("ja-JP");
}
export function formatDateTime(date: Date): string {
  return format(date, "yyyy-MM-dd HH:mm");
}

export const convertDateFormat = (dateString: string) => {
  // 'YYYY-MM-dd'形式の文字列をISO 8601形式の日付オブジェクトに変換
  const date = parseISO(dateString);
  // 日付オブジェクトを'MM/dd'形式の文字列にフォーマット
  return format(date, "MM/dd");
};
export function formatTime(date: Date): string {
  return format(date, "HH:mm ss");
}
